import CellChipComponent from './FormField/cell-chip'
import CellDropdownComponent from './FormField/cell-dropdown'
import CellFileUploadComponent from './FormField/cell-file-upload'
import CellBooleanComponent from './FormField/cell-boolean'
import CellBooleanRadioComponent from './FormField/cell-boolean-radio'
import CellMultiDropdownComponent from './FormField/cell-multi-select'
import CellStringComponent from './FormField/cell-string'
import CellNumberComponent from './FormField/cell-number'
import CellTextareaComponent from './FormField/cell-textarea'
import CellDynamicSelectComponent from './FormField/cell-dynamic-select'
import PropTypes from 'prop-types'

const FormFieldDictionary = {
  string: CellStringComponent,
  dropdown: CellDropdownComponent,
  'multi-select': CellMultiDropdownComponent,
  'file-upload': CellFileUploadComponent,
  number: CellNumberComponent,
  integer: CellNumberComponent,
  boolean: CellBooleanComponent,
  radio: CellBooleanRadioComponent,
  array: CellChipComponent,
  textarea: CellTextareaComponent,
  'dynamic-select': CellDynamicSelectComponent,
  'dynamic-dropdown': CellDynamicSelectComponent,
}

const FormField = props => {
  const { type, ...otherProps } = props
  const Component = FormFieldDictionary[type]

  if (!Component) {
    return <CellStringComponent {...otherProps} />
  }

  return <Component {...otherProps} />
}

FormField.propTypes = {
  type: PropTypes.string,
}

export default FormField
